"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TagPickerControl: function() {
        return _TagPickerControl.TagPickerControl;
    },
    iconSizes: function() {
        return _useTagPickerControlStylesstyles.iconSizes;
    },
    renderTagPickerControl_unstable: function() {
        return _renderTagPickerControl.renderTagPickerControl_unstable;
    },
    tagPickerControlAsideWidthToken: function() {
        return _useTagPickerControlStylesstyles.tagPickerControlAsideWidthToken;
    },
    tagPickerControlClassNames: function() {
        return _useTagPickerControlStylesstyles.tagPickerControlClassNames;
    },
    useTagPickerControlStyles_unstable: function() {
        return _useTagPickerControlStylesstyles.useTagPickerControlStyles_unstable;
    },
    useTagPickerControl_unstable: function() {
        return _useTagPickerControl.useTagPickerControl_unstable;
    }
});
const _TagPickerControl = require("./TagPickerControl");
const _renderTagPickerControl = require("./renderTagPickerControl");
const _useTagPickerControl = require("./useTagPickerControl");
const _useTagPickerControlStylesstyles = require("./useTagPickerControlStyles.styles");
